// extracted by mini-css-extract-plugin
module.exports = {"container":"Firmware_container__1kXmo","nav-link-active":"Firmware_nav-link-active__3H7ys","tab-style":"Firmware_tab-style__srzfm"};